export const TEMPLATE_NAMES = Object.freeze({
  PFIZER_FREE_DRUG: "pfizer-free-drug",
  GENENTECH_COPAY: "genentech-copay",
  GENENTECH_FREE_DRUG: "genentech-free-drug",
  PFIZER_COPAY_ORAL: "pfizer-copay-oral",
  PFIZER_COPAY_ORAL_IQVIA: "pfizer-copay-oral-iqvia",
  PFIZER_COPAY_IV: "pfizer-copay-iv",
  EAGLE_PEMFEXY: "eagle-pemfexy",
  NOVARTIS_COPAY: "novartis-copay",
  BMS_COPAY: "bms-copay",
  REGENERON_COPAY: "regeneron-copay",
  REGENERON_PAP: "regeneron-pap",
  PFIZER_FREE_DRUG_SONNEXUS: "pfizer-free-drug-sonnexus",
  LILLY_COPAY: "lilly-copay",
  LILLY_COPAY_SIGNATURE: "lilly-copay-signature",
  TEVA_COPAY: "teva-copay"
});
